export enum NursingHomeChannel {
  CREATE = 'nursingHome::create',
  EDIT = 'nursingHome::patch',
  DELETE = 'nursingHome::delete',
}
